export enum SearchProgressPercentage {
  SearchStarted = 25,
  AnchorReceived = 40,
  HotelsReceived = 60,
  OffersReceived = 85, // 25% of the progress bar is reserved for the offers requests. from 60% to 85%
  SearchCompleted = 100
}
